export const addToCart = (productId, value) => {
    if (window.env !== 'local') {
        if (typeof window.DY === 'undefined') {
            const int = setInterval(() => {
                if (typeof window.DY !== 'undefined') {
                    clearInterval(int);
                    addToCart(productId, value);
                }
            }, 100);
        } else {
            if (typeof window.DY !== 'undefined') {
                console.log('DY addToCart', productId, value);
                window.DY.API('event', {
                    name: 'IBE - Add to Cart',
                    properties: {
                        dyType: 'add-to-cart-v1',
                        value: value ?? 0,
                        productId,
                        quantity: 1
                    }
                });
            }
        }
    }
};

export const viewStep = (stepName) => {
    // Check if DY is loaded - should not be necessary anymore since loading the tag in the head but better safe than sorry
    if (window.env !== 'local') {
        if (typeof window.DY === 'undefined') {
            const int = setInterval(() => {
                if (typeof window.DY !== 'undefined') {
                    clearInterval(int);
                    viewStep(stepName);
                }
            }, 100);
        } else {
            if (typeof window.DY !== 'undefined') {
                console.log('DY view Step', stepName);
                window.DY.API('event', {
                    name: 'IBE - Step',
                    properties: {
                        stepName
                    }
                });
                window.DY.recommendationContext = {
                    type: 'OTHER',
                    data: [
                        'step',
                        stepName
                    ]
                };

                const consentManager = document.cookie
                    .split('; ')
                    .find(row => row.startsWith('CONSENTMGR='))
                    ?.split('=')[1] ?? '';

                const hasConsent = !consentManager.includes('c2:0') && consentManager.includes('consent:true');

                window.DY.userActiveConsent = {
                    accepted: hasConsent
                };
            }
        }
    }
};
